export default function isValidHTMLElement(mountNode) {
  return mountNode && mountNode.nodeType === 1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-named-media-query/node_modules/fela-utils/es/isValidHTMLElement.js
// module id = 985
// module chunks = 1